import _, { isEmpty } from "lodash";
import { create, doMocked, isMocked, read, update, remove } from "../api";
import { key } from "./action";
export const SERVICE_ENDPOINT = "models";
export const SERVICE_ENDPOINT_UPDATE_MODEL = `${SERVICE_ENDPOINT}/update`;
export const SERVICE_ENDPOINT_DELETE_MODEL = `${SERVICE_ENDPOINT}/remove`;
export const SERVICE_ENDPOINT_READ_MODELS = `${SERVICE_ENDPOINT}/read`;
export const SERVICE_ENDPOINT_READ_MODEL = `${SERVICE_ENDPOINT}/testModel/read`;
export const SERVICE_ENDPOINT_RUN_MODEL = `${SERVICE_ENDPOINT}/testModel/run`;
export const SERVICE_ENDPOINT_CANCEL_MODEL = `${SERVICE_ENDPOINT}/testModel/cancel`;
export const SERVICE_ENDPOINT_PROGRESS_MODEL = `${SERVICE_ENDPOINT}/testModel/progress`;

export const updateModel = (body) => {
  let modelName = body.modelName;
  if (body.id) {
    modelName = body.id;
    body = _.omit(body, "id");
  }
  if (isMocked()) return doMocked(key, SERVICE_ENDPOINT_UPDATE_MODEL);
  return update(`${SERVICE_ENDPOINT}/${modelName}`, body, null, true);
};

export const deleteModel = (body) => {
  const { modelName } = body;
  if (isMocked()) return doMocked(key, SERVICE_ENDPOINT_DELETE_MODEL);
  return remove(`${SERVICE_ENDPOINT}/${modelName}`, null, true);
};

export const readModels = () => {
  if (isMocked()) return doMocked(key, SERVICE_ENDPOINT_READ_MODELS);
  return read(`${SERVICE_ENDPOINT}`, null, true);
};

export const readModel = (body) => {
  const { modelName, owner, isShared } = body;
  if (isMocked()) return doMocked(key, SERVICE_ENDPOINT_READ_MODEL);
  if (isEmpty(body)) {
    return;
  }
  const query = isShared && owner ? { owner } : null;
  return read(`${SERVICE_ENDPOINT}/${modelName}`, query, true);
};

export const runModel = (body) => {
  const { modelName, input } = body;
  if (isMocked()) return doMocked(key, SERVICE_ENDPOINT_RUN_MODEL);
  return create(`${SERVICE_ENDPOINT}/${modelName}/run`, input, null, true);
};

export const cancelModel = (body) => {
  const { modelName } = body;
  if (isMocked()) return doMocked(key, SERVICE_ENDPOINT_CANCEL_MODEL);
  return create(`${SERVICE_ENDPOINT}/${modelName}/cancel`, null, null, true);
};

export const getModelProgress = (body) => {
  if (!isEmpty(body)) {
    const { modelName, owner, isShared } = body;
    if (isMocked()) return doMocked(key, SERVICE_ENDPOINT_PROGRESS_MODEL);
    const query = isShared && owner ? { owner } : null;
    return read(`${SERVICE_ENDPOINT}/${modelName}/progress`, query, true);
  } else {
    return;
  }
};

export const updateModelCompletionEmailPreference = (body) => {
  const { modelName, notifyOnCompletionEmail } = body;
  if (isMocked()) return doMocked(key, SERVICE_ENDPOINT_UPDATE_MODEL);
  return update(
    `${SERVICE_ENDPOINT}/${modelName}/notify_on_completion`,
    { notifyOnCompletionEmail },
    null,
    true
  );
};

export const shareModel = (body) => {
  const { modelName, email } = body;
  return create(`${SERVICE_ENDPOINT}/${modelName}/shares`, { email }, null, true);
};

export const readModelShares = (body) => {
  const { modelName } = body;
  return read(`${SERVICE_ENDPOINT}/${modelName}/shares`, null, true);
};

export const revokeModelShare = (body) => {
  const { modelName, shareTarget } = body;
  return remove(`${SERVICE_ENDPOINT}/${modelName}/shares/${shareTarget}`, null, true);
};
